import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import TicketForm from '../components/TicketForm';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';

export default function NewTicket() {
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState('');
  const [success, setSuccess] = useState('');
  const navigate = useNavigate();
  const { user } = useAuth();

  const now = new Date();
  const localISO = new Date(now.getTime() - now.getTimezoneOffset()*60000).toISOString().slice(0,16);

  const initial = {
    opened_on: localISO,
    opened_by_name: '', opened_by_email:'',
    support_plan_id:'', product_type_id:'', platform_id:'',
    ats_consultant_id:'', sales_manager_id:'', client_id:'',
    priority:'Medium', status:'Open',
    issue_short_desc:'', issue_detail_desc:'',
    classification_id:'', category_id:'',
    operating_system:'', product_version:'',
    gtl_responded_on:'', latest_update_note:'',
    resolution_desc:'', remarks:''
  };

  const handleSubmit = async (form, calls) => {
    setLoading(true); setError(''); setSuccess('');
    try {
      const { data } = await api.post('/tickets', { ...form, calls });
      setSuccess(`Ticket ${data.ticket_id} created successfully!`);
      setTimeout(() => navigate(`/tickets/${data.ticket_id}`), 1500);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create ticket');
    } finally { setLoading(false); }
  };

  return (
    <Layout title="New Ticket">
      {/* isEdit=false: hides call details, resolution, remarks; Opened On editable */}
      <TicketForm
        initial={initial}
        onSubmit={handleSubmit}
        loading={loading}
        error={error}
        success={success}
        isEdit={false}
      />
    </Layout>
  );
}
